<div class="wrapper confinement">
  <div class="back-link-container content-box-only-width">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'ACCOUNT.MY_ADDRESSES.TITLE' | translate }}</a
    >
  </div>
  <mat-card class="content-box confinement">
    <mat-card-title class="mat-title">
      {{ 'ACCOUNT.ADD_ADDRESS.TITLE' | translate }}
    </mat-card-title>
    <mat-card-content class="mat-card-info">
      <p>{{ 'ACCOUNT.ADD_ADDRESS.INFO' | translate }}</p>
      <ng-container *ngIf="formState$ | async as formState">
        <form [ngrxFormState]="formState">
          <div class="form-container">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.NAME' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.firstName" />
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.SURNAME' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.lastName" />
            </mat-form-field>
          </div>
          <mat-form-field class="form-field" appearance="fill" gdColumns="auto">
            <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.STREET_AND_HOUSE_NUMBER' | translate }}</mat-label>
            <input matInput type="text" [ngrxFormControlState]="formState.controls.street" />
          </mat-form-field>
          <div class="postal-code">
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.POSTAL_CODE' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.postalCode" />
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.CITY' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.city" />
            </mat-form-field>
          </div>
        </form>
      </ng-container>
    </mat-card-content>
    <mat-card-actions>
      <mat-button-toggle
        #button
        class="mat-flat-button dark-plain-button"
        ngClass.sm="left-button"
        ngClass.xs="bottom-distance"
        ><mat-icon color="primary" class="star-icon">{{ button.checked ? 'star' : 'star_border' }}</mat-icon
        ><span>{{ 'GENERAL.SET_AS_DEFAULT' | translate }}</span></mat-button-toggle
      >
      <a mat-flat-button color="primary">{{ 'GENERAL.ADD' | translate }}</a>
    </mat-card-actions>
  </mat-card>
</div>
